import Separate from "./separate";
export default Separate;